var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-trash",staticStyle:{"float":"left"}},[_c('div',{staticClass:"trash-lid colorPrimary"}),_c('div',{staticClass:"trash-container colorPrimary"}),_c('div',{staticClass:"trash-line-1"}),_c('div',{staticClass:"trash-line-2"}),_c('div',{staticClass:"trash-line-3"})])
}]

export { render, staticRenderFns }